import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { useAuth } from './AuthProvider';
import defaultTheme, { paletteOptions } from '../themes/defaultTheme';
import logoAcronym from '../assets/base/logo.acronym.png';

const BrandingContext = React.createContext({
  facilityLogo: null,
  facilityLogoStyle: {},
});

export const useBranding = () => {
  const context = React.useContext(BrandingContext);
  if (!context) throw new Error('useBranding must be used within BrandingProvider');
  return context;
};

const buildFacilityTheme = (facility) => {
  const palette = {
    ...paletteOptions,
    ...(facility?.primary_color && { primary: { main: facility.primary_color } }),
    ...(facility?.secondary_color && { secondary: { main: facility.secondary_color } }),
  };
  const base = createTheme({ palette });
  return {
    ...base,
    icons: defaultTheme.icons,
    mobileBreakPoint: base.breakpoints.up('sm'),
  };
};

export const BrandingProvider = ({ children }) => {
  const { facility } = useAuth();

  const facilityTheme = React.useMemo(
    () => buildFacilityTheme(facility),
    [facility?.id, facility?.primary_color, facility?.secondary_color] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const facilityLogo = facility?.logo_url || logoAcronym;
  const facilityLogoStyle = facility?.logo_url ? {} : { filter: 'brightness(0) invert(1)' };

  return (
    <BrandingContext.Provider value={{ facilityLogo, facilityLogoStyle }}>
      <ThemeProvider theme={facilityTheme}>
        {children}
      </ThemeProvider>
    </BrandingContext.Provider>
  );
};
